import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdalAccessGuard } from './adal-access.guard';
import { AdalService } from './adal.service';
import { HTTP_INTERCEPTORS,HttpClientModule } from '@angular/common/http';
import { AuthInterceptor } from './auth-interceptor';
import { SearchableMultiSelectComponent } from './searchable-multi-select/searchable-multi-select.component';


export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
];

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule
  ],
  declarations: [SearchableMultiSelectComponent],
  exports: [SearchableMultiSelectComponent],
  providers: [AdalService, AdalAccessGuard, httpInterceptorProviders]
})


export class SharedModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/shared.module.ts